import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

export default function Unsubscribed() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const hasError = searchParams.get("error") === "true";

  useEffect(() => {
    if (hasError) {
      toast({
        title: "Error",
        description: "There was a problem unsubscribing. Please try again or contact support.",
        variant: "destructive",
      });
    }
  }, [hasError, toast]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/20 flex items-center justify-center">
      <div className="bg-card border border-border rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="text-success text-5xl mb-4">✓</div>
        <h1 className="text-2xl font-bold mb-2">Successfully Unsubscribed</h1>
        <p className="text-muted-foreground mb-6">
          You've been unsubscribed from the 21-Day AI Challenge. You won't receive any more emails from us.
        </p>
        <p className="text-sm text-muted-foreground mb-6">
          Changed your mind? You can always resubscribe by entering your email on our home page.
        </p>
        <div className="flex gap-3">
          <Button onClick={() => navigate("/")} className="flex-1">
            Back to Home
          </Button>
          <Button onClick={() => navigate("/")} variant="outline" className="flex-1">
            Resubscribe
          </Button>
        </div>
        <div className="mt-6 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Thank you for being part of <span className="font-semibold text-primary">Daily Spark AI</span>
          </p>
        </div>
      </div>
    </div>
  );
}
